module.exports = __webpack_public_path__ + "static/media/crop_unselected_w.a3408a17.svg";